module.exports = __webpack_public_path__ + "media/components/assets/icons/sns_yes-056fcc4449653a91809c86ed5b06fc12.svg";